// extracted by mini-css-extract-plugin
export default {"content_curriculo":"section_curriculo_content_curriculo__+zgSu","container_about":"section_curriculo_container_about__t6ZoT"};